module.exports = __webpack_public_path__ + "static/anga-iscrizione-cat-8E-materia3-3f02749065e2a3a1ccbd3b4ebda99989.pdf";